import { CURRENCIES_FETCH } from "../../actions/others/currencyActions";

const currencyReducer = (state: any[] = [], action: any) => {
  switch (action.type) {
    case CURRENCIES_FETCH:
      return action.payload;
    default:
      return state;
  }
};

export default currencyReducer;
